import CalendarImage from "../../images/personalPage/calendar.svg";
import ClockImage from "../../images/personalPage/clock.svg";
import CashImage from "../../images/personalPage/money.svg";
import PersonalDefaultPage from "./PersonalDefaultPage";

import moment from "moment-timezone";

import axios from "axios";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Config from "../../Config";
import { Calendar } from "../../components/Calendar";
import { UpcomingLessonsBlock } from "../../components/Tables/LessonsTable";
import { IconInfoBlock } from "../../components/blocks/IconInfoBlock";
import { ImageBlock } from "../../components/blocks/ImageBlock";
import ModalPrompt from "../../components/blocks/ModalPrompt";
import ModalTimeZone from "../../components/blocks/ModalTimeZone";
import { get_user } from "../../components/blocks/profileUpdating/dataUpdating/ProfileDataUpdatingBlock";
import { ProfileUpdatingModal } from "../../components/blocks/profileUpdating/profileUpdatingModal/ProfileUpdatingModal";
import {
  WeeklyTask,
  WeeklyTasksList,
} from "../../components/blocks/weeklyTasks/weeklyTasksList/WeeklyTasksList";
import ClassroomLinksModal from "../../components/classroom/ClassroomLinksModal";
import { LoadingContainer } from "../../components/containers/LoadingContainer";
import { LogOut } from "../../components/redirects/LogOut";
import { setUser, updateUser } from "../../store/UserSlice";
import getRussianNumberEnding from "../../utilities/rusNumbers";
import { useWindowDimensions } from "../../utils";
import { useI18n } from "../../i18n/I18nProvider";

export async function getMyId() {
  let id = Cookies.get("user_id");
  if (id === null || id === undefined) {
    LogOut();
  }
  return id;
}
export async function getWeeklyTasksList() {
  let response = await axios.get(
    Config.BACKEND_ADDR + `/tasks/user_tasks/${await getMyId()}`,
  );
  let userTasksData = [...response.data];
  userTasksData = userTasksData.sort((a, b) => a.id - b.id);
  console.log("userTasksData", userTasksData);
  return userTasksData.map(
    (el) => new WeeklyTask(el.id, el.task_text, el.completed),
  );
}

const PersonalPage = () => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { height: screenHeight, width: screenWidth } = useWindowDimensions();
  const [profileUpdatingState, setProfileUpdatingState] = useState(false);
  const [imageUpdatingState, setImageUpdatingState] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [modalOpen, setModalOpen] = useState(false);
  const [changeData, setChangeData] = useState({
    changeIcon: CalendarImage,
    changeIconColor: "#8DB3FF",
    changeText: t("Проведено занятий"),
    changeValue: 0,
    changeType: "lesson_cost",
    patchUrl: "/auth/update_user",
  });

  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user);

  const [timeZoneModalOpen, setTimeZoneModalOpen] = useState(false);
  const [selectedTimeZone, setSelectedTimeZone] = useState(
    userData.time_zone || "",
  ); // По умолчанию пользовательский часовой пояс
  const [ipTimeZone, setIpTimeZone] = useState("");
  const [classroomModalOpen, setClassroomModalOpen] = useState(false);
  const [nowForCountdown, setNowForCountdown] = useState(() => moment());
  useEffect(() => {
    const id = setInterval(() => setNowForCountdown(moment()), 1000);
    return () => clearInterval(id);
  }, []);

  const checkTimeZone = async (userTimeZone) => {
    try {
      // Проверяем, проверяли ли мы уже часовой пояс по IP
      const timeZoneChecked = sessionStorage.getItem("timeZoneChecked");
      if (timeZoneChecked) {
        console.log("Часовой пояс уже проверен ранее.");
        return false; // Если уже проверяли, возвращаем false
      }

      // Получение часового пояса по IP-адресу
      const protocol = window.location.protocol;
      //const protocol = "http:"
      /* 
            let ipApiUrl = "//members.ip-api.com/";
            if (protocol !== "https:") {
                ipApiUrl = "//ip-api.com/json/";
            }
            */
      //const ipApiResponse = await axios.get(`${protocol}${ipApiUrl}`);
      const ipApiResponse = await axios.get(
        `${protocol}//api.ipgeolocation.io/v2/timezone?apiKey=682b377c19e3419fa7b1cff001207827`,
      );
      //const ipTimeZone = ipApiResponse.data.timezone; // Часовой пояс по IP
      const ipTimeZone = ipApiResponse.data.time_zone.name; // Часовой пояс по IP
      setIpTimeZone(ipTimeZone || "Europe/Moscow"); // Сохранение часового пояса по IP в состоянии
      // Получение системного часового пояса
      const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      console.log("Часовой пояс по IP:", ipTimeZone);
      console.log("Системный часовой пояс:", systemTimeZone);
      console.log("Часовой пояс пользователя:", userTimeZone);

      // Сравнение часовых поясов
      if (ipTimeZone !== userTimeZone) {
        console.warn("Часовой пояс по IP отличается от user.time_zone!");
        return true;
      }

      if (ipTimeZone !== systemTimeZone) {
        console.warn("Часовой пояс по IP отличается от системного!");
        return false;
      }

      if (systemTimeZone !== userTimeZone) {
        console.warn("Системный часовой пояс отличается от user.time_zone!");
        return false;
      }
    } catch (error) {
      console.error("Ошибка при проверке часового пояса:", error);
      return false; // Возвращаем false в случае ошибки
    }
  };

  useEffect(() => {
    get_user().then((data) => {
      setIsLoading(false);
      console.log("userData: ", data);
      dispatch(setUser(data));

      let backendAddr = Config.BACKEND_ADDR + "/payments/getSubscriptionPeriod"; // /api
      axios
        .get(backendAddr)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.status === "not_paid") {
              navigate("/billing");
            }
          }
        })
        .catch((err) => {
          console.warn("Ошибка проверки подписки в БД! ", err);
        });

      checkTimeZone(data.time_zone)
        .then((resultCheckedTimeZone) =>
          setTimeZoneModalOpen(resultCheckedTimeZone),
        )
        .catch((error) => setTimeZoneModalOpen(false));
    });
  }, []);

  const handleOpenTimeZoneModal = () => {
    setTimeZoneModalOpen(true);
  };

  const handleSaveTimeZone = () => {
    console.log("Выбранный часовой пояс:", selectedTimeZone);
    setTimeZoneModalOpen(false);
    // Здесь можно обновить часовой пояс пользователя на сервере, если нужно

    // Например, отправить PATCH-запрос с новым значением часового пояса
    getMyId()
      .then((id) => {
        console.warn(userData);
        let requestData = {
          full_name: userData.name,
          image: userData.image,
          phone_number: userData.phoneNumber,
          time_zone: selectedTimeZone,
        };
        console.warn(requestData);
        axios
          .patch(Config.BACKEND_ADDR + `/auth/user/${id}`, requestData)
          .then((response) => {
            console.log("RESPONSE", response);

            dispatch(
              updateUser({
                time_zone: selectedTimeZone,
              }),
            );
            //alert("Данные успешно обновлены")
            sessionStorage.setItem("timeZoneChecked", "true");
          })
          .catch((error) => {
            alert(t("Ошибка обновления данных ") + error);
          });
      })
      .catch(() => {
        alert(t("Ошибка получения ID пользователя"));
      });
  };

  const handleSaveModalPrompt = () => {
    let data = {};
    data[changeData.changeType] = +changeData.changeValue;

    axios
      .patch(Config.BACKEND_ADDR + changeData.patchUrl, data)
      .catch((err) => {
        console.log(err);
        alert(t("Ошибка обновления данных "));
      })
      .then(() => {
        // TODO: убрать реплейс, разные названия на бэкенде и на фронте
        //data[changeData.changeType.replace("lesson_cost", "lessonPrice")] = changeData.changeValue;
        dispatch(updateUser(data));
        setModalOpen(false);
      });
  };

  return (
    <>
      <PersonalDefaultPage>
        <LoadingContainer isLoading={isLoading}>
          <ModalTimeZone
            isOpen={timeZoneModalOpen}
            onClose={() => setTimeZoneModalOpen(false)}
            userData={userData}
            ipTimeZone={ipTimeZone}
            selectedTimeZone={selectedTimeZone}
            setSelectedTimeZone={setSelectedTimeZone}
            handleSaveTimeZone={handleSaveTimeZone}
          />

          <ModalPrompt
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            changeData={changeData}
            setChangeData={setChangeData}
            student={{}}
            user={userData}
            onSave={handleSaveModalPrompt}
            patchUrl={"/auth/update_user"}
          />

          <ProfileUpdatingModal
            isOpen={profileUpdatingState || imageUpdatingState}
            profileUpdatingState={profileUpdatingState}
            imageUpdatingState={imageUpdatingState}
            onRequestClose={() => {
              setProfileUpdatingState(false);
              setImageUpdatingState(false);
            }}
          />
          <ClassroomLinksModal
            isOpen={classroomModalOpen}
            onRequestClose={() => setClassroomModalOpen(false)}
          />
          <div
            style={{
              display: "flex",
              flexDirection: screenWidth > 1180 ? "row" : "column",
              alignItems: "flex-start",
              gap: 20,
              width: "100%",
              ...(screenWidth >= 1600 && {
                justifyContent: "space-between",
              }),
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 20,
                justifyContent: "flex-start",
                ...(screenWidth >= 1600
                  ? { flex: 1, minWidth: 0, maxWidth: 1178 }
                  : screenWidth > 1180
                    ? { width: 730 }
                    : { width: screenWidth - 50 }),
              }}
            >
              <ImageBlock
                profileName={userData.name}
                imageLink={userData.image}
                changeButtonHandler={() => setProfileUpdatingState(true)}
                changeImageButtonHandler={() => setImageUpdatingState(true)}
                secondaryButtonLabel={t("Создать урок")}
                secondaryButtonHandler={() => setClassroomModalOpen(true)}
                //secondaryButtonBeta
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: screenWidth <= 740 ? 8 : 16, // до 400px уменьшаем, чтобы три блока влезали
                  width: "100%",
                  ...(screenWidth >= 1600 && { alignItems: "stretch" }),
                }}
              >
                <IconInfoBlock
                  imageLink={CalendarImage}
                  title={t("{{count}} урок{{ending}}", {
                    count: userData.total_lessons,
                    ending: getRussianNumberEnding(userData.total_lessons),
                  })}
                  description={t("Проведено")}
                  onClick={() => {
                    setChangeData(
                      Object.assign(changeData, {
                        changeIcon: CalendarImage,
                        changeIconColor: "#8DB3FF",
                        changeText: t("Проведено занятий"),
                        changeValue: userData.total_lessons,
                        changeType: "total_lessons",
                        patchUrl: "/auth/teacher/totalLessons",
                      }),
                    );

                    setModalOpen(true);
                  }}
                ></IconInfoBlock>
                <IconInfoBlock
                  imageLink={CashImage}
                  title={`${userData.balance}$`}
                  description={t("Мой баланс")}
                  onClick={() => {
                    setChangeData(
                      Object.assign(changeData, {
                        changeIcon: CashImage,
                        changeIconColor: "#8DB3FF",
                        changeText: t("Баланс"),
                        changeValue: userData.balance,
                        changeType: "balance",
                        patchUrl: "/auth/teacher/balance",
                      }),
                    );

                    setModalOpen(true);
                  }}
                ></IconInfoBlock>
                {userData?.lessonsList?.[0] ? (
                  (() => {
                    const now = nowForCountdown
                      .clone()
                      .tz(userData.time_zone || "Europe/Moscow");
                    const startTime = userData?.lessonsList?.[0].start_time;
                    if (!startTime || !moment(startTime).isValid()) {
                      return (
                        <IconInfoBlock
                          imageLink={ClockImage}
                          title={t("Нет следующего урока")}
                          description={""}
                        ></IconInfoBlock>
                      );
                    }
                    const lessonTime = moment(startTime).tz(
                      userData.time_zone || "Europe/Moscow",
                    );
                    if (!lessonTime || !lessonTime.isValid()) {
                      return (
                        <IconInfoBlock
                          imageLink={ClockImage}
                          title={t("Нет следующего урока")}
                          description={""}
                        ></IconInfoBlock>
                      );
                    }

                    const duration =
                      lessonTime && now && lessonTime.isValid() && now.isValid()
                        ? moment.duration(lessonTime.diff(now))
                        : moment.duration(0);
                    const hours = duration.hours();
                    const minutes = duration.minutes();
                    const seconds = duration.seconds();
                    const days = duration.days();
                    const pad2 = (n) =>
                      String(Math.max(0, Math.floor(n))).padStart(2, "0");
                    const isPhone = screenWidth <= 740;
                    const displayTime =
                      duration.asMilliseconds() <= 0
                        ? "00:00:00"
                        : days >= 1
                          ? isPhone
                            ? t("{{hours}} ч. {{minutes}} м.", {
                                hours: days * 24 + hours,
                                minutes,
                              })
                            : t("{{days}}{{hours}}{{minutes}} м.", {
                                days: days > 0 ? t("{{count}} д. ", { count: days }) : "",
                                hours: hours > 0 ? t("{{count}} ч. ", { count: hours }) : "",
                                minutes,
                              })
                          : `${pad2(hours)}:${pad2(minutes)}:${pad2(seconds)}`;
                    return (
                      <IconInfoBlock
                        imageLink={ClockImage}
                        title={displayTime}
                        description={t("До урока")}
                      ></IconInfoBlock>
                    );
                  })()
                ) : (
                  <IconInfoBlock
                    imageLink={ClockImage}
                    title={`00:00:00`}
                    description={t("Нет уроков")}
                  ></IconInfoBlock>
                )}
              </div>
              <UpcomingLessonsBlock lessonsList={userData.lessonsList || []} />
            </div>
            <div
              style={{
                ...(screenWidth >= 1600
                  ? { flex: 1, minWidth: 380, maxWidth: 480 }
                  : {
                      width:
                        screenWidth > 1180 ? "fit-content" : screenWidth - 50,
                    }),
                display: "flex",
                flexDirection: screenWidth > 1180 ? "column" : "row",
                flexWrap: "wrap",
                justifyContent: screenWidth > 1180 ? "flex-start" : "center",
                alignSelf: screenWidth > 1180 ? "auto" : "center",
                gap: 20,
              }}
            >
              <WeeklyTasksList />
              <Calendar />
            </div>
          </div>
        </LoadingContainer>
      </PersonalDefaultPage>
    </>
  );
};

export default PersonalPage;
